import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import deleteMutation from "@/v2-backoffice-client/layer/authoring/layer.authoring.delete.mutation.gql"
import restoreMutation from "@/v2-backoffice-client/layer/authoring/layer.authoring.restore.mutation.gql"
import promoteMutation from "@/v2-backoffice-client/layer/authoring/layer.authoring.promote.mutation.gql"
import type {
  StudioLayerDeleteMutation,
  StudioLayerDeleteMutationVariables,
} from "@/v2-backoffice-client/layer/authoring/__types__/layer.authoring.delete.mutation"
import type {
  StudioLayerRestoreMutation,
  StudioLayerRestoreMutationVariables,
} from "@/v2-backoffice-client/layer/authoring/__types__/layer.authoring.restore.mutation"
import type {
  StudioLayerPromoteMutation,
  StudioLayerPromoteMutationVariables,
} from "@/v2-backoffice-client/layer/authoring/__types__/layer.authoring.promote.mutation"

type DeleteOptions = MutationHookOptions<
  StudioLayerDeleteMutation,
  StudioLayerDeleteMutationVariables
>

/** Soft-deletes a catalog row: the next publish removes it from runtimes. */
export function useLayerAuthoringDeleteMutation(options?: DeleteOptions) {
  return useMutation<
    StudioLayerDeleteMutation,
    StudioLayerDeleteMutationVariables
  >(deleteMutation, options)
}

type RestoreOptions = MutationHookOptions<
  StudioLayerRestoreMutation,
  StudioLayerRestoreMutationVariables
>

export function useLayerAuthoringRestoreMutation(options?: RestoreOptions) {
  return useMutation<
    StudioLayerRestoreMutation,
    StudioLayerRestoreMutationVariables
  >(restoreMutation, options)
}

type PromoteOptions = MutationHookOptions<
  StudioLayerPromoteMutation,
  StudioLayerPromoteMutationVariables
>

/** Copies the dev catalog row over prod ("push to production"). */
export function useLayerAuthoringPromoteMutation(options?: PromoteOptions) {
  return useMutation<
    StudioLayerPromoteMutation,
    StudioLayerPromoteMutationVariables
  >(promoteMutation, options)
}
